/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var skipLink = document.querySelector('.skip-to-content');
  if (!skipLink) return;

  function ensureSkipLinkFirst() {
    if (document.body.firstElementChild !== skipLink) {
      document.body.insertBefore(skipLink, document.body.firstChild);
    }
  }

  // Run once immediately in case nothing has injected yet
  ensureSkipLinkFirst();

  // Watch for anything else getting prepended to <body> (e.g. app-injected bars)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        ensureSkipLinkFirst();
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true });
})();

(function () {
  function fixOneTrustTimeSlotLabel(root) {
    root = root || document;
    var input = root.querySelector('#ot-time-slot');
    if (input && !input.getAttribute('aria-label')) {
      input.setAttribute('aria-label', 'Preferred delivery time slot');
    }
  }

  fixOneTrustTimeSlotLabel();

  var observer = new MutationObserver(function () {
    fixOneTrustTimeSlotLabel();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function syncAnnouncementBarFocusability(root) {
    root = root || document;
    root.querySelectorAll('.bstndsls-bar-slide').forEach(function (slide) {
      var hidden = slide.getAttribute('aria-hidden') === 'true';
      slide.querySelectorAll('a, button, input, [tabindex]').forEach(function (el) {
        if (hidden) {
          if (!el.hasAttribute('data-original-tabindex')) {
            el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
          }
          el.setAttribute('tabindex', '-1');
        } else if (el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
          el.removeAttribute('data-original-tabindex');
        }
      });
    });
  }

  // Run on load for any slides already in the DOM
  syncAnnouncementBarFocusability();

  // Re-run whenever aria-hidden toggles (slide change) or new slides render
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
        syncAnnouncementBarFocusability(m.target.closest('.bstndsls-bar-slider-container') || document);
      } else if (m.type === 'childList') {
        syncAnnouncementBarFocusability();
      }
    });
  });

  document.querySelectorAll('.bstndsls-bar-slider-container').forEach(function (container) {
    observer.observe(container, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true, childList: true });
  });
})();